import type { App } from "vue"
import type { ModuleDefinition, ModuleOptions } from "@core/types/module"

const subscriptionModule: ModuleDefinition = {
    name: "subscription",

    install(_app: App, _options: ModuleOptions): void {
        // Module parcours d'inscription + paiement Stripe
    },
}

export default subscriptionModule
